/* eslint-disable */
export default {
  notActivated: '非使用中',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
